import Vue from "vue";
import App from "./App.vue";
import Vant from "vant";
import {Lazyload} from "vant";
import "vant/lib/index.css";
import router from "./router/routes";
import '@vant/touch-emulator';
import axios from "axios";
// import moment from "moment"; //导入文件

// Vue.prototype.$moment = moment; //赋值使用

// moment.locale("zh-cn"); //需要汉化
import debounce from '../src/mixins/debounce'
import {dialByPhone} from "./utils/common";
// 重置css
// import "reset-css";

Vue.mixin(debounce)
Vue.use(Vant);
Vue.use(Lazyload)
// Vue.use(moment)
Vue.config.productionTip = false;
window.dialByPhone = dialByPhone;

Vue.mixin({
  methods: {
    goBack() {
      this.$router.back();
    },
  },
});

// 动态修改浏览器导航栏图标和文字
export function changeIconTitle() {
	axios({
		method: 'get',
		url: `/cloud/api/sys/envValue`
	})
	.then((response)=>{
		const {result} = response.data
		localStorage.setItem('env', result.env)
		const changeFavicon = link => {
			let $favicon = document.querySelector('link[rel="icon"]');
			if ($favicon !== null) {
				$favicon.href = link;
			} else {
				$favicon = document.createElement("link");
				$favicon.rel = "icon";
				$favicon.href = link;
				document.head.appendChild($favicon);
			}
		};
    switch (localStorage.getItem('env')) {
      case 'wwjrxx':
        changeFavicon('/xxfavicon.ico')
        // document.title = '无为课堂';
        break;
      case 'wwgd':
        changeFavicon('/gdfavicon.ico')
        // document.title = '盘感课堂';
        break;
      default:
        changeFavicon('/')
        break;
    }
	});
	
}

changeIconTitle()

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
